<script>
  import { onMount } from "svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {Array} list of font family names
   */
  export let dropdownItems = [
    { type: "Image only", value: "image" },
    { type: "Text only", value: "text" },
    { type: "Hide Header", value: "empty" },
  ]

  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {String} the default or active font family in the dropdown area
   */
  let activeItem
  /**
   * @type {undefined} binded the overall dropdown parent element
   */
  let dropdown

  export let dispatchValue

  onMount(() => {
    dropdownItems.find((item) => {
      if (item.value == dispatchValue) {
        activeItem = item.type
      }
    })
  })

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="relative w-full" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    type="button"
    class="relative w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-left shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm"
  >
    <div class="flex justify-between">
      <div class="text-sm text-gray-800 dark:text-gray-200">{activeItem}</div>
      <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center text-gray-200">
        <i class="fa-solid fa-chevron-down" />
      </div>
    </div>
  </button>
  <ul style="padding-inline-start:0px;" class:hidden={!showDropdown} class="absolute z-10 mt-1 max-h-56 w-full flex-col overflow-auto rounded-md border border-[#a0a1a580] bg-white text-base ring-opacity-5 focus:outline-none dark:bg-darkgray sm:text-sm" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        on:click={(e) => {
          activeItem = item.type
          dispatchValue = item.value
          dispatch("changeType")
          showDropdown = false
        }}
        class="{activeItem == item.type ? 'bg-blue-500 text-white' : 'text-gray-500 hover:bg-[#f7f7f7] dark:hover:bg-black dark:hover:text-slate-200'} relative cursor-pointer select-none rounded-md py-2 pl-5 pr-9"
      >
        <div class="text-sm">{item.type}</div>
      </li>
    {/each}
  </ul>
</div>
